import { labelTransform } from "./labelTransform";

export const transformAllLabelsInObject = <T>(obj: T): T => {
  if (typeof obj === "string") {
    return labelTransform(obj) as unknown as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => transformAllLabelsInObject(item)) as unknown as T;
  }

  if (obj !== null && typeof obj === "object") {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = transformAllLabelsInObject((obj as any)[key]);
      }
    }
    return result;
  }

  return obj;
};
